import type { ReactNode } from 'react';

import { useIsImpersonating } from '~/api/user';
import { LoadingScreen } from '~/components';
import { env } from '~/constants/env';

import { ImpersonationBanner } from './ImpersonateBanner/ImpersonationBanner';
import { appStyle, contentWrapperStyle } from './Layout.css';
import { useIdentifyUserInSentry, useReloadOnUserSwitch, useUserColorTheme, useUserLanguage } from './Layout.hooks';
import { NavigationDesktop } from './NavigationDesktop';
import { NavigationMobile } from './NavigationMobile';
import { ProductFruits } from './ProductFruits/ProductFruits';
import { Prompts } from './Prompts/Prompts';
import { TopBar } from './TopBar/TopBar';

export const Layout = ({ children }: { children: ReactNode }) => {
  useUserColorTheme();
  useUserLanguage();
  useIdentifyUserInSentry();
  const hasSwitchedUser = useReloadOnUserSwitch();

  const isImpersonating = useIsImpersonating();

  if (hasSwitchedUser) return <LoadingScreen />;

  return (
    <div className={appStyle}>
      <NavigationDesktop />

      <div className={contentWrapperStyle}>
        <TopBar />

        <Prompts />

        {children}

        {env.PRODUCT_FRUITS_WORKSPACE_CODE && !isImpersonating && <ProductFruits workspaceCode={env.PRODUCT_FRUITS_WORKSPACE_CODE} />}

        <ImpersonationBanner />
      </div>

      <NavigationMobile />
    </div>
  );
};
